import { createLiveStore } from "../lib/live-store";
import type { AssetPhoto } from "../types/api";

interface AssetPhotosData {
  photos: AssetPhoto[];
}

interface AssetPhotosExtra {
  assetId: number | undefined;
  setAssetId: (id: number | undefined) => void;
}

export const useAssetPhotosStore = createLiveStore<AssetPhotosData, AssetPhotosExtra>({
  topic: (s) => (s.assetId ? `assets.photos.${s.assetId}` : null),
  onSnapshot: (data) => ({ photos: data as AssetPhoto[] }),
  state: (set) => ({
    photos: [],
    assetId: undefined,
    setAssetId: (id: number | undefined) => set({ assetId: id, photos: [], _loading: true } as any),
  }),
});
